// src/components/sections/ScrollMarquee.js
import React from 'react';
import ScrollVelocity from '../ScrollVelocity';

const ScrollMarquee = () => {
  const velocity = 50;

  return (
    <div className="my-20 bg-transparent">
      <ScrollVelocity
        texts={[
          '🖥️ Web Design & 📲 Mobile App Development Agency.',
          '🧠 Branding Agency & 📊 Business Consulting Concern.'
        ]}
        velocity={velocity}
        className="text-white text-2xl md:text-4xl lg:text-5xl font-semibold"
        parallaxClassName="py-2 md:py-4"
        scrollerClassName="gap-5"
      />
    </div>
  );
};

export default ScrollMarquee;